import { Tooltip } from "antd"
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FolderOpenFilled, GlobalOutlined, RocketOutlined, SearchOutlined, SettingOutlined, ShopFilled } from "@ant-design/icons";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { useFetch } from "../../../../../hooks/useFetch/useFetch";
import TableLZM from "../../../../components/design/table/TableLZM";
import { KeywordsDrawer } from "../../pageLocations/Drawer/KeywordsDrawer";
import { NewGeogridModal } from "./drawer/NewGeogridModal";
import { TableFilter } from "../../../../../common/utils/FilterUtils";
import { LocationCardCompacted } from "../../../../components/model/business/FieldsGroup";
import { Batch } from "../../../menuUsers/keywords/entity/TermUtils";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import { GeogridLocationDrawer } from "./drawer/GeogridLocationDrawer";
import { getLocalpackPresenceMetrics, LocalpackMetricsCard } from "../_common/RankingCardUtils";
import { KeywordResultKeyword } from "../_common/GridComponents";

export const LocalSEO = (props: {selectedType: any}) => {
	
    const [locations, setLocations] = useState(false);
    const [updateData, setUpdateData] = useState(false);	
    const [isLoading, setIsLoading] = useState(true);
	const [keywordsDrawer, setKeywordsDrawer] = useState(null);	
	const [newGeoGridModal, setNewGeoGridModal] = useState<any>(null);
	const [rankingsDrawer, setRankingsDrawer] = useState<any>(null);
    const { projectGroup } = useAuth();
    const { t } = useTranslation();
    
    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/keywords/' + projectGroup.group + '/locations?periodOpt=' + props.selectedType,
		{},
		[updateData],
		(data) => {
			setLocations(data);        
            setIsLoading(false);        
		}
	);

    const SEO_COLUMNS: any = [		
		{
			title: 'Establecimiento',
			key: 'location',			
			width: '200px',
			filterDropdown: TableFilter,
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
			  return record.location.title?.toLowerCase().includes(value?.toLowerCase()) 
			  || record.location?.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
			  || record.location?.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (				
				<LocationCardCompacted location={record.location} warning={!record.keywordMetrics}/>																		
			)			
		},		
		{
			title: 'Visibilidad por Keyword',
			key: 'terms',			
			render: (text: string, record: any) => (
				<div>													                                   
					{ record.keywordMetrics?.map((kw: any, index: number) => {
							const hasScan = kw.localPackPercent != null;
							const metrics = hasScan ? getLocalpackPresenceMetrics(kw) : null;
                            return 	(
							<div key={`${record.locationId}-${kw.term}-${index}`} style={{display:'grid', gridTemplateColumns:'25px minmax(0, 1fr)', alignItems:'center', columnGap: 8}}>
								<div>
									<Batch kw={kw} onFinish={() => {setUpdateData(!updateData) }} showLabel={false}/>
								</div>
								<div style={{
									display: 'grid',
									gridTemplateColumns: '220px minmax(360px, 1fr) auto',
									alignItems: 'stretch',
									columnGap: 10,
									margin: '4px 0',
									padding: '0 10px',
									minWidth: 0,
								}}>
									<KeywordResultKeyword keyword={kw.term} scope={kw.scope} />
									{hasScan && metrics ? (
										<LocalpackMetricsCard
											compact
											presencePercent={metrics.presencePercent}
											visibilityRadius={metrics.visibilityRadius}
											percentColor={metrics.percentColor}
											launchedAt={kw.created}
											onClick={() => {
												setRankingsDrawer({ locationId: record.locationId, keyword: kw });
											}}
										/>
									) : (
										<div style={{
											display: 'flex',
											alignItems: 'center',
											minHeight: '100%',
											padding: '4px 8px',
											border: '1.5px dashed #94a3b8',
											borderRadius: 6,
											background: '#f8fafc',
											boxSizing: 'border-box',
										}}>
											<small style={{ color: '#64748b', fontSize: 11 }}>
												<i>No se lanzó ningún estudio en este periodo</i>
											</small>
										</div>
									)}
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', paddingRight: 4 }}>
										<Tooltip title="Nuevo Escaneo">
											<span>
												<ButtonLZ size='small' type='primary' onClick={() => {setNewGeoGridModal({locationId: record.locationId, groupId: record.location.groupAccount, keyword: kw})}}>
													<RocketOutlined/> Lanzar
												</ButtonLZ>
											</span>
										</Tooltip>
									</div>
								</div>
							</div>
                        )})
                    }
					<div style={{ display: 'grid', gridTemplateColumns: '25px minmax(0, 1fr) auto', columnGap: 8, marginTop: 2 }}>
						<div />
						<div style={{
							display: 'grid',
							gridTemplateColumns: '220px minmax(360px, 1fr) auto',
							alignItems: 'center',
							columnGap: 10,
							padding: '0 10px',
							minWidth: 0,
						}}>
							<button
								type="button"
								onClick={() => setKeywordsDrawer(record.location)}
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									gap: 5,
									padding: 0,
									border: 'none',
									background: 'transparent',
									color: '#64748b',
									fontSize: 12,
									fontWeight: 500,
									cursor: 'pointer',
								}}
							>
								<SettingOutlined style={{ fontSize: 12 }} />
								Configurar keywords
							</button>
						</div>
					</div>
				</div>
			)
		}
	]

    return (
		<>                    
			<TableLZM
				rowKey='name'
				scroll={{ x: true, y: 800 }}
				columns={SEO_COLUMNS}
				dataSource={locations}
				loading={isLoading}
			/>

		{keywordsDrawer && <KeywordsDrawer location={keywordsDrawer} onFinish={(anyUpdate: boolean) => {setKeywordsDrawer(null);}} onRefresh={() => {setUpdateData(!updateData); ;}}/>}												
	
		{ newGeoGridModal && 
        <NewGeogridModal 
            locationId={newGeoGridModal.locationId}
            groupId={newGeoGridModal.groupId}
            keyword={newGeoGridModal.keyword} 
            onFinish={() => {setNewGeoGridModal(null); setUpdateData(!updateData)}}
            onClose={() => {setNewGeoGridModal(null);}}/>}

		{rankingsDrawer && (
			<GeogridLocationDrawer
				locationId={rankingsDrawer.locationId}
				keyword={rankingsDrawer.keyword}
				onFinish={() => setRankingsDrawer(null)}
			/>
		)}
		</>
    )
}


export const getColor = (positionDiff: number) => {
		
	if (positionDiff < -20) {
		return "black";		
	} else if (positionDiff <= -1) {
		return "Crimson";
	} else {
		return "SeaGreen";
	}
};

export const KW_SCOPE: any = {
    "DOMAIN": {icon: <GlobalOutlined/>, name: "dominio"},  
    "GROUP": {icon: <FolderOpenFilled />, name: "grupo"},  
    "LOCAL": {icon: <ShopFilled />, name: "local"},  
}
